import { twMerge } from "tailwind-merge";

const CardHeader = ({title, className}) => {
    return (
        <div className={twMerge("flex flex-col items-center p-6 md:py-8 md:px-10", className)}>
            <div className="inline-flex items-center gap-2">
                <h3
                    className="font-semibold text-xl sm:text-3xl mb-5 text-gray-800"
                    style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.25)" }}
                >
                    {title}
                </h3>
            </div>
        </div>
    )
}
export default CardHeader